import _ from "lodash";
import { findIndex } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { CASH_EXCEPTIONS, ERRORS, SPREAD } from "../../constants";
import { State } from "../../state";
import {
  getLanguage,
  getSpreadCashFlowsPeriods
} from "../model/spread/selector";
import { Spread } from "../model/spread/types";
import PAFColumn from "./PAFColumn";
import "./PersistentAccountingFormula.scss";

interface CashFlowFooterProps {
  periods: string[];
  spread?: Spread;
  language?: string | null;
}

interface CashFlowFooterState {
  activePeriodIndex: number;
}

export class CashFlowFooter extends React.Component<
  CashFlowFooterProps,
  CashFlowFooterState
> {
  constructor(props: CashFlowFooterProps) {
    super(props);
    this.state = {
      activePeriodIndex: 0
    };
  }

  public choosePeriod = (event: React.MouseEvent<HTMLButtonElement>) => {
    const activePeriodIndex = findIndex(
      period => period === event.currentTarget.value,
      this.props.periods
    );
    this.setState({ activePeriodIndex });
  };

  public render() {
    const { periods, spread } = this.props;

    const endingCashValue = this.periodValue(
      (spread && spread.financialTemplate.endingCashValues) || []
    );

    const { readExceptions, reportedValues } = this.generateReportedValues();
    const reportedValue = this.periodValue(reportedValues);

    const endingCashLabel =
      (spread && spread.financialTemplate.endingCashLabel) ||
      SPREAD.FINANCIAL_TEMPLATE.ENDING_CASH;

    // change this part after haveing translated lables for cash flow

    // if (
    //   this.props.language &&
    //   spread &&
    //   spread.financialTemplate.totalAssetsTranslatedLabels &&
    //   spread.financialTemplate.totalAssetsTranslatedLabels[this.props.language]
    // ) {
    //   totalAssetsLabel =
    //     spread.financialTemplate.totalAssetsTranslatedLabels[
    //       this.props.language
    //     ];
    // }

    return (
      <div className="PersistentAccountingFormula__container">
        <div className={"PersistentAccountingFormula__periods"}>
          {periods.map((period, index) => {
            const year = period.split("/")[2];
            return (
              <button
                className={this.displayAsActive(index)}
                key={period}
                onClick={this.choosePeriod}
                value={period}
              >
                {year}
              </button>
            );
          })}
        </div>
        <PAFColumn
          header={`CALCULATED ${endingCashLabel}`.toUpperCase()}
          value={endingCashValue}
        />
        <PAFColumn
          header={`REPORTED ${endingCashLabel}`.toUpperCase()}
          value={reportedValue}
          exceptionString={
            readExceptions[this.state.activePeriodIndex] ? "unread" : undefined
          }
        />
        <PAFColumn
          header="DIFFERENCE"
          value={endingCashValue - reportedValue}
          isDifference={true}
          exceptionString={
            readExceptions[this.state.activePeriodIndex] ? "-" : undefined
          }
        />
      </div>
    );
  }

  private generateReportedValues = () => {
    const readExceptions = {};
    const { periods, spread } = this.props;
    const documenteExceptions = (spread && spread.documentExceptions) || [];
    const reportedValues: any[] = [];

    const exceptionOverride = {};

    periods.map((period, idx) => {
      const exception = _.find(
        documenteExceptions,
        e =>
          e.period === period &&
          e.sheetName === CASH_EXCEPTIONS.SHEET_NAME &&
          e.type === ERRORS.PDF_READ_ERROR &&
          e.firstRow.exceptionValueModels[0].financialValueId.includes(
            CASH_EXCEPTIONS.ENDING_CASH_ID
          )
      );

      if (!readExceptions[idx] && exception) {
        readExceptions[idx] = exception;
      }

      if (!exceptionOverride[idx]) {
        exceptionOverride[idx] = _.find(
          documenteExceptions,
          e =>
            e.period === period &&
            e.firstRow.exceptionValueModels[0] &&
            e.firstRow.exceptionValueModels[0].financialValueId.includes(
              CASH_EXCEPTIONS.ENDING_CASH_ID
            )
        );
      }

      let value;

      value =
        exceptionOverride[idx] &&
        exceptionOverride[idx].firstRow.exceptionValueModels[0] &&
        exceptionOverride[idx].firstRow.exceptionValueModels[0].value;

      let v = spread && spread.financialTemplate.endingCashValues[idx];

      if (exceptionOverride[idx] && value) {
        v = value;
      }

      reportedValues.push(v);
    });

    return { readExceptions, reportedValues };
  };

  private periodValue = (valuesForPeriods: Array<number | undefined>) => {
    return valuesForPeriods[this.state.activePeriodIndex] || 0;
  };

  private displayAsActive = (periodIndex: number) => {
    return periodIndex === this.state.activePeriodIndex ? "active" : "inactive";
  };
}

const mapStateToProps = (state: State) => ({
  periods: getSpreadCashFlowsPeriods(state),
  language: getLanguage(state)
});

export default connect(mapStateToProps)(CashFlowFooter);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/CashFlowFooter.tsx